const SPECIAL_KEYS = ['backspace', 'arrowLeft', 'ArrowRight'].map((x) =>
  x.toLowerCase()
);

const keys = ['e', ',', '.'];
export const isValidAlphaNumericButNotNumeric = (key: string) => {
  const lowercaseKey = key.toLowerCase();
  return keys.indexOf(lowercaseKey) > -1;
};

const Numerics = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, ...SPECIAL_KEYS].map(String);
export const isNumeric = (key: string) => {
  const lowercaseKey = key.toLowerCase();
  return Numerics.indexOf(lowercaseKey) > -1;
};
